import { Focusable } from '@ariakit/react'
import * as React from 'react'
import styled from 'styled-components'

import { ProductCatalogEmbroideryPlacement } from '../../../../../../__generated__/graphql/catalog/graphql'
import { deriveNameFromEmbroideryPlacement } from '../../../../../../containers/EmbroideryContainer/utils/deriveNameFromEmbroideryPlacement'
import {
  ErrorMessage,
  Label,
  SelectedOptionText,
  SelectionButton,
  SelectionGroup,
} from '../../shared-form-styles'

export const PlacementSelector: React.FC<{
  errorMessage?: string
  label: string
  labelId: string
  onSelectPlacement(placement: ProductCatalogEmbroideryPlacement): void
  placementOptions: ProductCatalogEmbroideryPlacement[]
  selectedPlacementOption: ProductCatalogEmbroideryPlacement | undefined
  disabled?: boolean
}> = ({
  errorMessage,
  label,
  labelId,
  onSelectPlacement,
  placementOptions,
  selectedPlacementOption,
  disabled,
}) => {
  return (
    <>
      <Label disabled={disabled} id={labelId} inset>
        {label}{' '}
        {selectedPlacementOption ? (
          <SelectedOptionText disabled={disabled} aria-hidden>
            {deriveNameFromEmbroideryPlacement(selectedPlacementOption)}
          </SelectedOptionText>
        ) : null}
      </Label>

      <PlacementGroup $disabled={disabled} aria-labelledby={labelId} role='radiogroup'>
        {placementOptions.map((placementOption, index) => {
          const isSelected: boolean =
            selectedPlacementOption?.location === placementOption.location &&
            selectedPlacementOption.position === placementOption.position
          const placementOptionName = deriveNameFromEmbroideryPlacement(placementOption)
          return (
            <Focusable
              accessibleWhenDisabled
              key={index}
              disabled={disabled}
              render={
                <SelectionButton
                  aria-checked={isSelected}
                  isSelected={isSelected}
                  key={index}
                  onClick={() => {
                    onSelectPlacement(placementOption)
                  }}
                  role='radio'
                  type='button'
                >
                  {placementOptionName}
                </SelectionButton>
              }
            />
          )
        })}
      </PlacementGroup>

      {errorMessage && (
        <ErrorMessage inset role='alert'>
          {errorMessage}
        </ErrorMessage>
      )}
    </>
  )
}

const PlacementGroup = styled(SelectionGroup)`
  gap: ${o => o.theme.spacing(2.5)};
`
